import { observer } from "mobx-react-lite";
import React from "react";
import { getInteractionTriggerDataName } from "../../../../helper/displayHelpers";
import { MapElementSelector } from "../../selector/MapElementSelector";
import { formatTreeParameter } from "../../../../../shared/helper/actionTreeHelper";
import { editorMapStore, MapStatus } from "../../../../stores/EditorMapStore";
import { getTreeParentOfClosestActionModel } from "../../../../../shared/action/ActionTreeModel";
import { ElementParameter } from "../../../editor/ElementIcons";
import { getIconForElement, getImageForElement } from "../../../../helper/mapElementIconHelper";
import { editorStore } from "../../../../stores/EditorStore";
import { ElementGroup, ElementLabel } from "./BaseElements";
export const InteractionTriggerSelectionDetail = observer(({
  name,
  selectedInteractionTrigger,
  interactionTriggerSetter,
  allowBlankValue
}) => {
  const parentTree = getTreeParentOfClosestActionModel(selectedInteractionTrigger, true);
  const parameters = parentTree.treeParameterActions("actions/InteractionTriggerValueModel").map(treeParam => formatTreeParameter(treeParam.name));

  const getElements = mapId => {
    if (mapId === 0) {
      return {
        mapStatus: MapStatus.Loaded,
        mapName: undefined,
        elements: parameters.map(parameter => ({
          id: parameter,
          label: parameter,
          icon: /*#__PURE__*/React.createElement(ElementParameter, {
            key: parameter
          })
        }))
      };
    }

    const {
      map,
      mapStatus
    } = editorMapStore.getOrLoadMapWithMetaData(mapId, true);
    let interactionTriggers;

    if (map) {
      interactionTriggers = editorStore.isModuleEditor && map.moduleOwner !== editorStore.sessionModuleId ? map.interactionGateDataArray : map.interactionTriggerDataArray;
    } else {
      interactionTriggers = [];
    }

    return {
      mapStatus,
      mapName: map === null || map === void 0 ? void 0 : map.properties.name,
      elements: interactionTriggers.map(t => ({
        id: t.$modelId,
        label: getInteractionTriggerDataName(t),
        image: getImageForElement(t),
        icon: getIconForElement(t)
      }))
    };
  };

  return /*#__PURE__*/React.createElement(ElementGroup, null, name && /*#__PURE__*/React.createElement(ElementLabel, null, name), /*#__PURE__*/React.createElement(MapElementSelector, {
    selectedElement: selectedInteractionTrigger,
    elementSetter: interactionTriggerSetter,
    elementsGetter: getElements,
    allowBlankValue: allowBlankValue
  }));
});